import loadingMushroom from '../assets/loading-mushroom.svg';
import styles from './MatchmakingOverlay.module.css';

export interface MatchmakingOverlayProps {
  elapsedTime: number;
  onCancel: () => void;
}

function formatElapsedTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  if (mins > 0) {
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }
  return `0:${secs.toString().padStart(2, '0')}`;
}

export function MatchmakingOverlay({ elapsedTime, onCancel }: MatchmakingOverlayProps) {
  return (
    <div className={styles.overlay} role="status" aria-live="polite">
      <img
        src={loadingMushroom}
        alt="Searching for opponent"
        className={styles.spinner}
      />
      <span className={styles.message}>
        Searching the forest for an opponent...
      </span>
      <span className={styles.elapsedTime} aria-label={`Waiting for ${elapsedTime} seconds`}>
        {formatElapsedTime(elapsedTime)}
      </span>
      <button
        type="button"
        className={styles.cancelButton}
        onClick={onCancel}
      >
        Cancel
      </button>
    </div>
  );
}
